import { Directive, ElementRef, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[matTooltip][dssLibsUiTooltipIfTruncated]',
  host: {
    '(mouseenter)': 'check()',
    '(touchstart)': 'check()',
  },
})
export class TooltipIfTruncatedDirective {
  readonly #el = inject<ElementRef<HTMLElement>>(ElementRef);
  readonly #tooltip = inject(MatTooltip);

  check(): void {
    const el = this.#el.nativeElement;
    const style = getComputedStyle(el);
    const horizontallyTruncated = el.scrollWidth > el.clientWidth;
    const canWrap = style.whiteSpace !== 'nowrap' && style.whiteSpace !== 'pre';
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.2;
    const verticallyTruncated = canWrap && el.scrollHeight - el.clientHeight > lineHeight / 2;
    this.#tooltip.disabled = !(horizontallyTruncated || verticallyTruncated);
  }
}
